import request from '@/api/request'

function buildParams(data = {}) {
    const params = new URLSearchParams();
    Object.keys(data).forEach((key) => {
        let value = data[key];
        if (value !== undefined && value !== null && value !== '') {
            if (typeof value === 'boolean') {
                value = value ? 1 : 0;
            }
            params.append(key, value);
        }
    });
    return params.toString();
}

export function pageNlPromotionIncomeStatic(current,size,data) {
    let params = buildParams(data);
    return request({
        url: `/nlPromotionIncomeStatic/page?current=${current}&size=${size}${params ? `&${params}` : ''}`,
        method: 'get'
    })
}

export function exportNlPromotionIncomeStatic(data) {
    let params = buildParams(data);
    return request({
        url: `/nlPromotionIncomeStatic/export${params ? `?${params}` : ''}`,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        responseType: 'blob',
        method: 'post'
    })
}

export function exportNlMiniProgramStatic(data) {
    let params = buildParams(data);
    return request({
        url: `/nlPromotionIncomeStatic/exportMiniProgram${params ? `?${params}` : ''}`,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        responseType: 'blob',
        method: 'post'
    })
}


export function synchronizeMiniProgramData(date) {

    return request({
        url: `/nlPromotionIncomeStatic/synchronizeMiniProgramData/${date}`,
        method: 'post'
    })
}


export function statisticNlPromotionIncomeStatic(data) {
    let params = buildParams(data);
    return request({
        url: `/nlPromotionIncomeStatic/statistic${params ? `?${params}` : ''}`,

        method: 'get'
    })
}
export function getNlPromotionIncomeFilter() {
    return request({
        url: `/nlPromotionIncomeFilter`,
        method: 'get'
    })
}
export function updateNlPromotionIncomeFilter(data) {
    return request({
        url: `/nlPromotionIncomeFilter`,
        method: 'put',
        data
    })
}

export function listNlProgramInfo() {
    return request({
        url: `/nlPromotionProgram`,
        method: 'get'
    })
}

export function pageNlPromotionIncomeImportTask(current, size, data) {
    let params = buildParams(data);
    return request({
        url: `/nlPromotionIncomeStatic/importTask/page?current=${current}&size=${size}${params ? `&${params}` : ''}`,
        method: 'get'
    })
}
